export enum EnumSectionType {
    EXTOTHERSLO = 'EXTOTHERSLO',
    PENALTIES = 'PENALTIES',
    CRITICAL = 'CRITICAL'
}
